// Quy tắc sinh "Mã chủ vườn" có thể tuỳ chỉnh (Cài đặt > Quy tắc sinh mã).
// Mẫu là chuỗi có placeholder {tinh}/{xa}/{stt}, vd "LV-{tinh}-{xa}-{stt}".

export const LOAI_CHU_VUON_THUONG = "thuong";
export const LOAI_CHU_VUON_NHAN_VIEN = "nhan_vien";

export const NHAN_LOAI_CHU_VUON = {
  [LOAI_CHU_VUON_THUONG]: "Chủ vườn thường",
  [LOAI_CHU_VUON_NHAN_VIEN]: "Nhân viên nội bộ",
};

export const QUY_TAC_MAC_DINH = {
  mauThuong: "LV-{tinh}-{xa}-{stt}",
  mauNhanVien: "LV-NV-{stt}",
  soChuSoStt: 3,
};

/** Mẫu có {tinh} hoặc {xa} thì phải chọn địa chỉ trước khi sinh mã. */
export function mauCanDiaChi(mau) {
  const chuoi = String(mau ?? "");
  return chuoi.includes("{tinh}") || chuoi.includes("{xa}");
}

export function danhSachTruongThieuSinhMa(mau, { tinhMa, xaMa } = {}) {
  const chuoi = String(mau ?? "");
  const thieu = [];
  if (chuoi.includes("{tinh}") && !String(tinhMa ?? "").trim()) thieu.push("Tỉnh");
  if (chuoi.includes("{xa}") && !String(xaMa ?? "").trim()) thieu.push("Xã");
  return thieu;
}

export function kiemTraTruongSinhMa(mau, ctx) {
  const thieu = danhSachTruongThieuSinhMa(mau, ctx);
  if (thieu.length === 0) return;
  throw new Error(`Vui lòng chọn ${thieu.join(" và ")} để sinh mã chủ vườn.`);
}

export function apDungMauMa(mau, { tinh, xa, stt, soChuSoStt }) {
  kiemTraTruongSinhMa(mau, { tinhMa: tinh, xaMa: xa });
  const sttChuoi = String(stt).padStart(soChuSoStt, "0");
  return mau
    .replaceAll("{tinh}", String(tinh).trim())
    .replaceAll("{xa}", String(xa).trim())
    .replaceAll("{stt}", sttChuoi);
}

// Khoá bộ đếm số thứ tự: nhân viên nội bộ dùng chung 1 bộ đếm, chủ vườn
// thường đếm riêng theo từng cặp Tỉnh+Xã (đúng ý "chủ vườn đầu tiên ở 1 xã
// luôn là 001").
export function khoaBoDem({ loaiChuVuon, tinhMa, xaMa }) {
  return loaiChuVuon === LOAI_CHU_VUON_NHAN_VIEN ? "NV" : `${tinhMa || "XX"}_${xaMa || "XX"}`;
}
